import React from 'react';

import { ErrorBoundary, ErrorBoundaryProps } from './ErrorBoundary';

/* eslint-disable react-refresh/only-export-components */

// Functional wrapper to provide i18n context
export function ErrorBoundaryWithI18n(props: Omit<ErrorBoundaryProps, 't'>) {
  return <ErrorBoundary {...props} />;
}

// Higher-order component for wrapping components with error boundary
export function withErrorBoundary<P extends object>(
  Component: React.ComponentType<P>,
  errorBoundaryProps?: Omit<ErrorBoundaryProps, 'children' | 't'>
) {
  const WrappedComponent = (props: P) => (
    <ErrorBoundaryWithI18n {...errorBoundaryProps}>
      <Component {...props} />
    </ErrorBoundaryWithI18n>
  );

  WrappedComponent.displayName = `withErrorBoundary(${Component.displayName || Component.name})`;

  return WrappedComponent;
}
